export default __webpack_public_path__ + "greendot.4a162e59.svg";